import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { MissionsListPage } from '@/features/missions'

export const Route = createFileRoute('/_authenticated/_main/missoes')({
  head: () => ({
    meta: [{ title: buildPageTitle('Missões') }]
  }),
  component: MissionsListPage
})
